var map = {
	"./banner.jpg": "8d11",
	"./chunni001.jpg": "b28e",
	"./chunni02.jpg": "6df2",
	"./footer.jpg": "9b9f",
	"./jiaobi002.jpg": "d51c",
	"./sanfen003.jpg": "9f75",
	"./sanfen03.jpg": "049a",
	"./ximiannai004.jpg": "8d90",
	"./yanyingpan01.jpg": "e981"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a69b";